var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"muven-card"},[(!_vm.message)?_c('p',[_vm._v("Nada encontrado")]):_vm._e(),(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }